/**
 * Created by piotr.pozniak@thebeaverhead.com on 19/02/2024
 */

import React, { createRef, useEffect } from "react";
import HamburgerItem from "./HamburgerItem";
import { useClickOutsideDomHook } from "../../../hooks/useClickOutsideDomHook";

/**
 *
 * @param {boolean} disabled
 * @param {array} options
 * @returns {Element}
 * @constructor
 */
const HamburgerDropdown = ({ disabled, options, id }) => {
  const dropdownId = `dropdown-${id}`;
  const items = options.map((i, idx) => (
    <HamburgerItem key={idx} toggleId={dropdownId} {...i} />
  ));

  return (
    <div className="dropdown dropdown-action" id={dropdownId}>
      <a
        href={!disabled ? "#" : null}
        data-toggle={!disabled ? "dropdown" : ""}
        className="btn btn-white action-icon dropdown-toggle p-2"
        aria-expanded="false"
      >
        <i className="material-icons icon-md">more_vert</i>
      </a>
      <div className="dropdown-menu dropdown-menu-right">{items}</div>
    </div>
  );
};

export default HamburgerDropdown;
